module.exports = __webpack_public_path__ + "static/media/9DESA1.cee67566.jpg";